// `no-restricted-imports` blocks TanStack outside data-stack: widen this list instead, see `documentation/tables.md`.
/** The only TanStack types outside data-stack: our aliases, so a major version's type renames and generic arity stay in `tanstackTypes.ts`. */
export type { Column, ColumnDef, ColumnFiltersState, Row, RowData, RowSelectionState, Table } from './tanstackTypes';
/** Subscribes a component to table state: `useSelector(table.store, (state) => …)`, with `shallow` for an object. */
export { shallow, useSelector } from '@tanstack/react-store';
/** For rendering cells from an `OuterTableRow` override, such as `DriversOuterTableRow`. */
export { flexRender } from './tanstackPrimitives';
export {
    CommandPalette,
    GlobalCommandPalette,
    GlobalCommandPaletteInput,
    createCommandHelper,
    isAccessoryCount,
    isIconConfig,
} from './CommandPalette';
export type {
    AccessoryCount,
    CommandContext,
    CommandDefinition,
    CommandIcon,
    CommandPaletteProps,
    GlobalCommandContext,
    GlobalCommandDefinition,
    GlobalCommandPaletteInputProps,
    GlobalCommandPaletteProps,
    SearchableResource,
} from './CommandPalette';
export { createColumnHelper } from './createColumnHelper';
export { TableLoadError } from './DefaultEmptyPlaceholder';
export { formatAvailabilityDuration } from '../formatters/formatAvailabilityDuration';
export { formatQuantity, formatQuantityUnit } from '../formatters/formatQuantity';
export type { FormatQuantityOptions } from '../formatters/formatQuantity';
export { DEFAULT_EXPAND_COLUMN_ID } from './ExpandColumn';
export { DEFAULT_SELECT_COLUMN_ID, DefaultColumnSelectionWithSubRows, DefaultColumnSingleSelection } from './Selection';
export { createFilterValueUpdater, isFilterValue } from './Filters/createFilterValueUpdater';
export { FloatingSelectionBar } from './FloatingSelectionBar';
export type { FloatingSelectionBarProps } from './FloatingSelectionBar';
export { TanStackMenuBar } from './TanStackMenuBar';
export { tableSearchParams } from './useTableSearchState';
export {
    TanStackTable,
    useColumnDefs,
    useTanStackTable,
    useTanStackTablePagination,
    useTanStackTableState,
} from './TanStackTable';
export {
    AVAILABILITY_RENDER_OPTIONS,
    MONETARY_VALUE_RENDER_OPTIONS,
    QUANTITY_RENDER_OPTIONS,
    SupportedFilterFn,
} from './type';
export type {
    AdditionalFilter,
    ArraryFilterConfig,
    AvailabilityRenderOption,
    ColumnRenderOptionsState,
    ColumnSource,
    DateRange,
    EmptyCell,
    EnumFilterConfig,
    FilterValue,
    MonetaryValueFilterConfig,
    MonetaryValueRenderOption,
    NumberRange,
    QuantityFilterConfig,
    QuantityRenderOption,
    QuickFilter,
    RenderOptionConfig,
    TanStackTableProps,
    TanStackTableState,
} from './type';
export { describeTableView } from './utils/describeTableView';
export type { TableView, TableViewColumn, TableViewFilter, TableViewSort } from './utils/describeTableView';
export { arrayToggleItem, arrayToggleItems, generateFilterRequest, generateSortRequest, getOptionCount } from './utils';
